<template>
    <div class="widget-calendar">
        <dashboardCard heading='Hikari Usage' :data1="usageCount" :data2="usageMax" :data3="usageTime"></dashboardCard>
    </div>
</template>
<script>
import dashboardCard from "./DashboardCard.vue";
export default {
    name: "hikariDetail",
    components: {
        dashboardCard
    },
    data() {
        return {
            usageCount: {},
            usageMax: {},
            usageTime: {},
        };
    },
    methods: {
        getHikariUsage(dataType) {
            let data = {
                type: dataType
            };
            this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
                .then(response => {
                    this.usageCount.value = this.formatValue(response.server.data[0].value.toFixed(2));
                    this.usageCount.name = 'Count';
                    this.usageMax.value = this.formatTime((response.server.data[2].value).toFixed(2));
                    this.usageMax.name = 'Max';
                    const totalTime = response.server.data[1].value;
                    this.usageTime.value = this.formatTime(totalTime.toFixed(2));
                    this.usageTime.name = 'Total Time'
                    this.usageCount.description = 'Total number of connections used.';
                    this.usageMax.description = 'Longest time a single connection was used.';
                    this.usageTime.description = 'Total time all connections were used.';
                })
                .catch(error => {
                    console.log(error);
                });
        },
        formatValue(value) {
            return value > 100 ? (value / 1000).toFixed(2) + 'k' : value;
        },
        formatTime(seconds) {
            if (seconds < 60) {
                return `${seconds}s`;
            } else if (seconds < 3600) {
                const minutes = Math.floor(seconds / 60);
                return `${minutes}m`;
            } else {
                const hours = Math.floor(seconds / 3600);
                const minutes = Math.floor((seconds % 3600) / 60);
                const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
                return `${hours}h ${formattedMinutes}m`;
            }
        },
    },
    mounted() {
        this.getHikariUsage("HIKARICP_CONNECTIONS_USAGE");
    }
};
</script>